






































































































































































































































































































// vue
import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
// @ts-ignore
import { mapFields } from 'vuex-map-fields';

// plugins
import _, { flatten } from 'lodash';
import moment from 'moment-timezone';
import * as XLSX from 'xlsx';

// components
import QuotationPreview from '../components/QuotationPreview.vue';

// utils
import { directusApi } from '../api';

@Component({
    name: 'publication-detail-modal',
    components: {
        QuotationPreview,
    },
    computed: {
        ...mapState('auth', ['currentUser']),
        ...mapState('products', ['activeQuotationLoading']),
        ...mapFields({
            activeQuotation: 'products.activeQuotation',
            client: 'products.client',
        }),
        ...mapState('products', {
            activeQuotation: (state: any) => {
                const activeQuotation = state.activeQuotation;
                const client = state.client;
                activeQuotation.products.forEach((product) => {
                    if (product.monedaprecio == 'Dolares') {
                        if (client.listapreciosesp == '(Precio 3)') {
                            product.price = (product.precio3 * product.dollarPrice).toFixed(2);
                        } else {
                            product.price = (product.precio2 * product.dollarPrice).toFixed(2);
                        }
                    } else {
                        if (client.listapreciosesp == '(Precio 3)') {
                            product.price = product.precio3;
                        } else {
                            product.price = product.precio2;
                        }
                    }
                });
                return activeQuotation;
            },
        }),
    },
})
export default class PublicationDetailModal extends Vue {
    //
    // computed
    private currentUser!: any;
    private activeQuotation!: any;
    private activeQuotationLoading!: any;

    private previewMode: boolean = false;

    private mlQuotation: boolean = false;
    private mlListingType: boolean = false;
    private mlCategoriesList: Array<any> = [];
    private mlCategorySelected: any = null;
    private mlCategoryQuery: string = '';
    private mlShipmentCost: number = 0;
    private phoneValue: any = 0;
    private preventNextIteration: any = false;
    public client!: any;
    public userSelected: any = '';
    public warehouseSelected: any = '';

    intelisisQuotation() {
        setTimeout(() => {
            if (this.activeQuotation.intelisis && !this.client.cliente) {
                this.client.cliente = 'V';
                this.client.listapreciosesp = '(Precio 2)';
                this.client.nombre = 'VENTA MOSTRADOR';
            }
        }, 100);
    }

    onCreateOrder() {
        //create order
        let clearQuotation = {
            clientName: '',
            clientEmail: '',
            clientPhone: '',
            products: [],
        };
        this.$store.dispatch('products/postOneOrder', {
            vm: this,
            newOrder: this.activeQuotation,
            user: this.currentUser,
        });
        this.$store.dispatch('products/setQuotation', clearQuotation);
        this.$bvModal.hide('product-quotation-modal');
    }

    onCreateQuotation() {
        if (!this.userSelected) {
            this.$bvToast.toast('Debes completar la información para continuar', {
                title: `Datos insuficientes`,
                variant: 'warning',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
        } else {
            console.log('creating quoation in intelisis...');
            var date = moment(moment(), 'YYYY/MM/DD');
            let quoationId = date.format('YY') + date.format('MM') + date.format('DD');
            let items = [];
            this.activeQuotation.products.forEach((item: any) => {
                items.push({
                    sku: item.sku,
                    price: +item.price,
                    qty: +item.qty,
                    subtotal: +item.price * +item.qty,
                });
            });
            let payload = {
                user: this.userSelected,
                warehouse: this.warehouseSelected,
                client: this.client.cliente,
                precio: this.client.listapreciosesp,
                items: items,
                quoationId,
            };
            this.$store.dispatch('products/postQuotation', { payload, vm: this });
            // this.$store.dispatch('products/setQuotation', {
            //     clientName: '',
            //     clientEmail: '',
            //     clientPhone: '',
            //     products: [],
            // });
            // this.$bvModal.hide('product-quotation-modal');
        }
    }

    private async onGenerateExcel() {
        let html = this.activeQuotation.products.reduce((acc: any, val: any) => {
            return val.sku ? acc + `<tr><td>${val.sku}</td><td>${val.qty}</td></tr>` : '';
        }, '');
        const wb: XLSX.WorkBook = XLSX.read(`<table>${html}</table>`, {
            type: 'string',
        });
        XLSX.writeFile(wb, `${moment().format('YYMMDDHHmmss')}.xls`);
    }

    private clearCategory() {
        this.mlCategorySelected = null;
    }

    private ensurePositiveNumber($event: any) {
        $event = $event ? $event : window.event;
        var charCode = $event.which ? $event.which : $event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
            $event.preventDefault();
        } else {
            return true;
        }
    }

    private setMlCategory($event: any) {
        console.log($event);
        this.mlCategorySelected = $event;
    }

    get cost() {
        if (this.client.cliente) {
            this.activeQuotation.clientEmail = this.client.email1;
            this.activeQuotation.clientName = this.client.nombre;
            this.activeQuotation.clientPhone = this.client.telefonos;
        } else {
            this.activeQuotation.clientEmail = '';
            this.activeQuotation.clientName = '';
            this.activeQuotation.clientPhone = '';
        }
        let constante_z: number = 0;
        let subtotal_shipment: number = 0;
        let subtotal: number = this.activeQuotation.products.reduce((a: any, p: any) => a + p.price * p.qty, 0);
        let limite_envio: number = 0;
        if (this.mlQuotation && this.mlCategorySelected != null) {
            let category_comission: any = '';
            this.mlListingType
                ? (category_comission = this.mlCategorySelected.gold_pro)
                : (category_comission = this.mlCategorySelected.gold_special);
            constante_z = 1 / (1 - category_comission);
            limite_envio = 298.5 / constante_z - 25;
            this.mlShipmentCost = +this.mlShipmentCost;
            subtotal_shipment = subtotal;
            subtotal = subtotal * constante_z;
        }
        if (this.activeQuotation.globalDiscount > 0) {
            if (this.client.listapreciosesp == '(Precio 3)') {
                this.activeQuotation.globalDiscount = 0;
            }
            if (this.activeQuotation.globalDiscount > 6) {
                this.activeQuotation.globalDiscount = 6;
            }
            subtotal = subtotal - (subtotal * this.activeQuotation.globalDiscount) / 100;
        }

        let iva = subtotal * 0.16;
        if (this.mlShipmentCost > 0 && this.mlQuotation && this.mlCategorySelected != null) {
            subtotal = (subtotal_shipment + this.mlShipmentCost) * constante_z;
        }
        if (subtotal + iva <= limite_envio) {
            subtotal = subtotal + 25;
        }
        return {
            subtotal,
            iva,
            total: subtotal + iva,
        };
    }

    activeQuotationProductsHeaders = [
        { thClass: 'th', key: 'menu', label: '' },
        { thClass: 'th', key: 'id', label: 'SKU Intelisis' },
        { thClass: 'th', key: 'manufacturersku', label: 'SKU Fabricante' },
        { thClass: 'th', key: 'title', label: 'Descripción' },
        { thClass: 'th', key: 'note', label: 'Nota' },
        { thClass: 'th', key: 'qty', label: 'Cantidad' },
        { thClass: 'th', key: 'import', label: 'Importe' },
    ];

    private onAddQuotationItem() {
        this.activeQuotation.products.push({
            id: '',
            type: 'custom',
            title: '',
            price: 1,
            qty: 1,
            note: '',
        });
    }

    private onRemoveQuotationItem(index: number) {
        this.activeQuotation.products.splice(index, 1);
    }

    private onPrint() {
        if (this.activeQuotation.products.length <= 0) {
            alert('Aún no hay artículos en la lista');
            return false;
        }

        // console.log('Current user => ', this.currentUser);
        // console.log('Current products => ', this.activeQuotation.products);
        // @ts-ignore
        const html = this.onGenerateHtml(true);

        // Open the print window
        const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

        // @ts-ignore
        WinPrint.document.write(html);
        // @ts-ignore
        WinPrint.document.close();
        // @ts-ignore
        WinPrint.focus();
        // @ts-ignore
        setTimeout(() => {
            WinPrint.print();
        }, 500);
    }

    private onGenerateHtml(isPDF = false) {
        // si son 8 partidas 1 pagina
        // si son más de 8, renderea 9 en la primera pagina sin bloque de total
        const max_items_per_page = isPDF ? 8 : 9999;
        const expiration = 5;
        const page_height = 964;
        const black = '#1a1a1a';
        const gray = '#b3b3b3';
        const blue = '#0000ff';

        let htmlBuild = '';
        let style = '';
        let big_logo = 'https://directus.prodelec.app/assets/a02991de-09d5-4913-b7d4-981d8ab809ec';
        let small_logo = 'https://directus.prodelec.app/assets/5f3c9661-2efe-449c-aec4-0290c73da4ea';

        style += `@import url('https://fonts.googleapis.com/css?family=Montserrat:300,500,700,800&display=swap');`;
        style += `html { font-family: 'Montserrat'; }`;
        style += `p { margin: 0; }`;
        style += `body { font-size: 11px; color: ${black}; }`;
        style += `table { width: 100%; border-collapse: collapse; }`;
        style += `.page { display: flex; flex-direction: column; height: ${page_height}px; justify-content: space-between; }`;

        // header

        style += `#page-header tr { height: 20px; }`;
        style += `#page-header th { text-align: left; width: 4%; font-weight: bold; }`;
        style += `#page-header td { text-align: left; width: 15% }`;

        //data

        style += `#page-data tr:not(:first-of-type) { height: 76.8px; }`;
        style += `#page-data tr th:nth-last-child(5) { width: 10% }`; //CANTIDAD
        style += `#page-data tr th:nth-last-child(4) { }`; //CLAVE
        style += `#page-data tr th:nth-last-child(3) { }`; //DESCRIPCIÓN
        style += `#page-data tr th:nth-last-child(2) { width: 20% }`; //PRECIO UNITARIO
        style += `#page-data tr th:nth-last-child(1) { width: 15% }`; //IMPORTE
        style += `#page-data tr td:nth-last-child(2) { text-align: right; }`;
        style += `#page-data tr td:nth-last-child(1) { text-align: right; }`;
        style += `#page-data th { padding-top: 10px; padding-bottom: 10px; text-align: left; font-weight: bold; font-size: 10px; text-transform: uppercase; border-bottom: 1px solid ${gray}; color: ${gray}; }`;
        style += `#page-data td { padding-top: 10px; padding-bottom: 10px; vertical-align: top; border-bottom: 1px solid ${gray}; }`;

        //total

        style += `#page-total tr { height: 20px; }`;
        style += `#page-total td { vertical-align: top; }`;
        style += `#page-total tr td:nth-last-child(2) { width: 15%; text-align: right; }`;
        style += `#page-total tr td:nth-last-child(1) { width: 15%; text-align: right; }`;
        style += `#page-total tr:last-of-type td:nth-last-child(2) { border-top: 1px solid ${gray}; }`;
        style += `#page-total tr:last-of-type td:nth-last-child(1) { border-top: 1px solid ${gray}; }`;
        style += `#page-total tr:nth-of-type(1) td { padding-top: 10px; }`;
        style += `#page-total tr:nth-of-type(2) td { padding-top: 10px; padding-bottom: 10px; }`;
        style += `#page-total tr:nth-last-of-type(1) td { padding-top: 10px; }`;

        //footer

        style += `#page-footer tr { height: 20px; }`;
        style += `#page-footer tr th:nth-child(1) { width: 25%; text-align: left; }`;
        style += `#page-footer tr th:nth-child(2) { width: 25%; text-align: left; }`;
        style += `#page-footer tr td:nth-child(3) { text-align: right; }`;
        style += `#page-footer th { color: ${blue}; font-weight: normal; }`;

        // PAGE START

        htmlBuild += `<!DOCTYPE html>`;
        htmlBuild += `<html>`;
        htmlBuild += `<head>`;
        htmlBuild += `<style>${style}</style>`;
        htmlBuild += `<title>Cotización</title>`;
        htmlBuild += `</head>`;
        htmlBuild += `<body>`;

        let pages: any = [];

        _.chunk(this.activeQuotation.products, max_items_per_page).forEach((products, index) => {
            pages.push({
                index: index + 1,
                products,
                has_total: false,
            });
        });

        pages[pages.length - 1] = {
            ...pages[pages.length - 1],
            has_total: true,
        };

        // PAGE

        pages.forEach((page: any) => {
            htmlBuild += `<div class="page">`;
            htmlBuild += `<div class="upper">`;

            // PAGE HEADER

            htmlBuild += `<table id="page-header">`;

            htmlBuild += `<tr>`;
            htmlBuild += `<td style="text-align:left;vertical-align:top;" rowspan="6"><img src="${big_logo}" width="160px"></td>`;
            htmlBuild += `<th>Cotización</th><td>N/A</td>`;
            if (this.activeQuotation.globalDiscount > 0) {
                htmlBuild += `<th>Descuento</th><td>%${this.activeQuotation.globalDiscount}</td>`;
            }
            htmlBuild += `</tr>`;

            htmlBuild += `<tr>`;
            htmlBuild += `<th>Elaboración</th><td>${moment().format('DD/MM/YYYY')}</td>`;
            htmlBuild += `<th>Vigencia</th><td>${expiration} días hábiles</td>`;
            htmlBuild += `</tr><tr></tr>`;

            htmlBuild += `<tr>`;
            htmlBuild += `<th>Atención a</th><td>${this.activeQuotation.clientName || 'Quien Corresponda'}</td>`;
            htmlBuild += `<th>Vendedor</th><td>${this.currentUser.first_name} ${this.currentUser.last_name}</td>`;
            htmlBuild += `</tr>`;

            htmlBuild += `<tr>`;
            htmlBuild += `<th>E-mail</th><td>${this.activeQuotation.clientEmail}</td>`;
            htmlBuild += `<th>E-mail</th><td>${this.currentUser.email}</td>`;
            htmlBuild += `</tr>`;

            htmlBuild += `<tr>`;
            htmlBuild += `<th>Teléfono</th><td>${this.activeQuotation.clientPhone}</td>`;
            // htmlBuild += `<th>Teléfono</th><td>${this.currentUser.phone}</td>`;
            htmlBuild += `<th>Teléfono</th><td></td>`;
            htmlBuild += `</tr>`;

            // htmlBuild += `<tr>`;
            // // htmlBuild += `<th></th><td></td>`;
            // htmlBuild += `<th>Descuento</th><td>%${this.activeQuotation.globalDiscount}</td>`;
            // htmlBuild += `</tr>`;

            htmlBuild += `<tr></tr><tr></tr>`;

            htmlBuild += `</table>`;

            // DATA

            htmlBuild += `<table id="page-data">`;

            htmlBuild += `<tr>`;
            htmlBuild += `<th >Cantidad</th>`;
            htmlBuild += `<th>Clave</th>`;
            htmlBuild += `<th>Descripción</th>`;
            htmlBuild += `<th>Precio Unitario</th>`;
            htmlBuild += `<th>Importe</th>`;
            htmlBuild += `</tr>`;

            page.products.forEach((product: any) => {
                htmlBuild += `<tr>`;
                htmlBuild += `<td>${product.qty}</td>`;
                htmlBuild += `<td>${product.sku || ''}</td>`;
                htmlBuild += `<td>`;
                htmlBuild += `<p>${product.descripcion1}</p>`;
                htmlBuild += `<p><small>${product.note}</small></p>`;
                htmlBuild += `</td>`;
                htmlBuild += `<td style="text-align: center;">${this.$options.filters.currency(product.price)}</td>`;
                htmlBuild += `<td style="text-align: center;">${this.$options.filters.currency((product.qty * product.price).toFixed(2))}</td>`;
                htmlBuild += `</tr>`;
            });

            htmlBuild += '</table>';

            // PAGE TOTAL

            if (page.has_total) {
                htmlBuild += '<table id="page-total">';

                htmlBuild += `<tr>`;
                htmlBuild += `<td rowspan="3">NOTA: <i> Los montos están en moneda nacional MXN. Oferta sujeta a la disponibilidad de productos y cambio de precios sin previo aviso. </i> <br> ${this.activeQuotation.note}</td>`;
                htmlBuild += `<td>SUBTOTAL</td>`;
                // @ts-ignore
                htmlBuild += `<td>${this.$options.filters.currency(this.cost.subtotal)}</td>`;
                htmlBuild += `</tr>`;

                htmlBuild += `<tr>`;
                htmlBuild += `<td>IVA</td>`;
                // @ts-ignore
                htmlBuild += `<td>${this.$options.filters.currency(this.cost.iva)}</td>`;
                htmlBuild += `</tr>`;

                htmlBuild += `<tr>`;
                htmlBuild += `<td>TOTAL</td>`;
                // @ts-ignore
                htmlBuild += `<td>${this.$options.filters.currency(this.cost.total)}</td>`;
                htmlBuild += `</tr>`;

                htmlBuild += `</table>`;
            }

            htmlBuild += `</div>`;
            htmlBuild += `<div class="lower">`;

            // PAGE FOOTER

            htmlBuild += `<table id="page-footer">`;

            htmlBuild += `<tr></tr>`;

            htmlBuild += `<tr>`;
            htmlBuild += `<th><p style="font-size:15px;font-weight:semi-bold;"><img width="12px" src="${small_logo}"> www.prodelec.mx</p></th>`;
            htmlBuild += `<th>info@prodelec.mx</th>`;
            htmlBuild += `</tr>`;

            htmlBuild += `<tr>`;
            htmlBuild += `<th>Morelia, Michoacán, México</th>`;
            htmlBuild += `<th>(443) 316 2300</th>`;
            htmlBuild += `<td rowspan="2">Página ${page.index} de ${pages.length}</td>`;
            htmlBuild += `</tr>`;

            htmlBuild += `</table>`;

            htmlBuild += `</div>`;
            htmlBuild += `</div>`;
        });

        // PAGE END

        htmlBuild += `</body>`;
        htmlBuild += `</html>`;

        return htmlBuild;
    }

    canSee(roles: any) {
        return _.intersection(roles, [this.currentUser.role.name]).length > 0;
    }

    mounted() {
        // mover a state
        console.log(this.currentUser.role.name);
        if (
            this.currentUser.role.name == 'MercadoLibre Manager' ||
            this.currentUser.role.name == 'Admin' ||
            this.currentUser.role.name == 'Developer'
        ) {
            directusApi('GET', `items/mercadolibre_categories`)
                .then((response: any) => {
                    this.mlCategoriesList = response.data.data;
                })
                .catch((e) => console.log(e));
        }
    }

    phoneNumberValidation(event) {
        // console.log(event);
        if (['Arrow', 'Backspace', 'Shift'].includes(event.key)) {
            this.preventNextIteration = true;
            return;
        }
        if (this.preventNextIteration) {
            this.preventNextIteration = false;
            return;
        }
        this.phoneValue = this.activeQuotation.clientPhone.replace(/-/g, '').match(/(\d{1,10})/g)[0];
        this.activeQuotation.clientPhone = this.phoneValue.replace(/(\d{1,3})(\d{1,3})(\d{1,4})/g, '$1-$2-$3');
    }
}
